<template>
  <ConditionGroup
    :properties="properties"
    :model-value="modelValue"
    :max-depth="2"
    @update:model-value="(x) => emit('update:modelValue', x)" />
</template>

<script lang="ts" setup>
import type { GroupCondition, ConditionEditorProperty } from "@/lib/helpers/condition";
import ConditionGroup from "./group.vue";

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: "update:modelValue", condition: GroupCondition): void;
}>();

defineProps<{
  modelValue: GroupCondition;
  properties?: ConditionEditorProperty[];
}>();
</script>
